import { Col, Row } from 'antd';
import { Routes } from 'config/routes';
import { Button } from 'modules/common/components';
import { CreateDonationForm } from 'modules/donations/components';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CreateDonationPage: FC = () => {
  const { t } = useTranslation('donation.CreateDonationPage');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const donorId = searchParams.get('donorId');

  return (
    <ProfileSideMenuWrapper title={t('pageTitle')}>
      <Button
        type="primary"
        onClick={() => navigate(`${Routes.Donors}/${donorId}`)}
      >
        {t('goBackToDonorProfile')}
      </Button>
      <Row>
        <Col span={24}>
          <CreateDonationForm />
        </Col>
      </Row>
    </ProfileSideMenuWrapper>
  );
};

export default CreateDonationPage;
